<template>
  <div class="slide-fade-modal">
    <transition name="fade">
      <div v-if="displayed" class="slide-fade-modal__background" @click="onOutsideClick" />
    </transition>
    <transition name="slide">
      <div v-if="displayed" class="slide-fade-modal__content" @click.stop>
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * Modal with a slide and fade effect
 *
 * @vue-prop {Boolean} displayed - ID of the action to edit, or 0 if new action
 * @vue-prop {Array} assignableTeams - IDs of the teams that may be assigned this action
 */

export default {

  name: 'SlideFadeModal',

  props: {
    displayed: Boolean,
  },

  data() {
    return {
    };
  },

  computed: {
  },

  watch: {
  },

  created() {
  },

  methods: {
    onOutsideClick() {
      this.$emit('outsideClick');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.slide-fade-modal {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;

  &__background {
    background: $modal-background;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: -1;
    pointer-events: auto;
  }

  &__content {
    overflow: auto;
    width: 50%;
    margin-left: 50%;
    height: 100%;
    background: #fff;
    padding: 1.71em 2.86em;
    box-sizing: border-box;
    pointer-events: auto;
  }
}

@media (max-width: $smartphone-landscape) {
  .slide-fade-modal {
    width: 100%;

    &__content {
      width: 90%;
      margin-left: 10%;
      height: 100%;
      background: #fff;
      padding: .7em 1.5em;
      box-sizing: border-box;
    }
  }
}
</style>
